import type {
  ColDef,
  ColGroupDef,
  ICellRendererParams
} from 'ag-grid-enterprise';

import { getCountryName } from '@/utils/Common.utils';

const ASSET_CONNECTIVITY_COLUMNS: (ColDef | ColGroupDef)[] = [
  {
    field: 'ip_address',
    headerName: 'IP Address',
    width: 175,
    minWidth: 175,
    suppressHeaderMenuButton: true
  },
  {
    field: 'country_code',
    headerName: 'Location',
    width: 250,
    flex: 1,
    cellRenderer: (params: ICellRendererParams) => getCountryName(params.value),
    suppressHeaderMenuButton: true
  },
  {
    field: 'count',
    headerName: 'Count',
    width: 100,
    suppressHeaderMenuButton: true,
    sort: 'desc'
  }
];

export default ASSET_CONNECTIVITY_COLUMNS;
